import { render, staticRenderFns } from "./CustomDatePicker.vue?vue&type=template&id=36a89f92&scoped=true"
import script from "./CustomDatePicker.vue?vue&type=script&lang=js"
export * from "./CustomDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a89f92",
  null
  
)

export default component.exports